import { useApolloClient } from "@vue/apollo-composable";
import { handleError } from "@/services/AlertService";
import type { StripeSessionModel } from "@/models/checkout/StripeSessionModel";
import CreateStripeSession from "../queries/CreateStripeSession.graphql";

export function createStripeSession(input: string | StripeSessionModel) {
    const { client } = useApolloClient();
    return new Promise(async (resolve, reject) => {
        try {
            // Handle legacy string input (bookingId only)
            let variables: Record<string, any>;

            if (typeof input === "string") {
                variables = { bookingId: input };
            } else {
                variables = {
                    bookingId: input.bookingId,
                };

                // Only add optional parameters if they exist
                if (input.fulfilmentMethod) {
                    // Convert string to enum if needed
                    variables.fulfilmentMethod = input.fulfilmentMethod;
                }
                if (input.guestCustomerEmail) {
                    variables.guestCustomerEmail = input.guestCustomerEmail;
                }
                if (input.guestCustomerFirstName) {
                    variables.guestCustomerFirstName = input.guestCustomerFirstName;
                }
                if (input.guestCustomerLastName) {
                    variables.guestCustomerLastName = input.guestCustomerLastName;
                }
            }

            const result = await client.query({
                query: CreateStripeSession,
                variables,
            });

            if (result.data.createStripeSession) {
                resolve(result.data.createStripeSession);
                return;
            }

            resolve(null);
            return;
        } catch (error) {
            console.error(error);
            handleError(error);
            reject(error);
        }
    });
}
